import './index.scss';
import 'utils/floating_labels';
import FormSubmitToggle from 'utils/form_submit_toggle';
import SignupEmailAssist from 'utils/signup_email_assist';

new FormSubmitToggle('#registration_form', true);
new SignupEmailAssist('#registration_form');
